import { ParityPrice } from "bigmac-index-price-calculator"
import ROLE_UPGRADES_MAP from '../../constants/roleUpgrades'

const parityPrice = new ParityPrice(process.env.GATSBY_PARITY_IPSTACK_KEY, true)

export const priceReducer = (state, action) => {
    switch (action.type) {
      case "loaded":
        return {
          ...action.data,
        }
      default:
        return state
    }
}

export const calcPrices = async (price, dispatch) => {
    // parityPrice is internally memoized so this fires only 1 request
    let upgradeTier = await parityPrice.price(price)
    let adjusted = true
    const { location } = await parityPrice.priceWithLocation(upgradeTier)

     if (upgradeTier >= price) {
        upgradeTier = price
        adjusted = false
     }

    dispatch({
      type: "loaded",
      data: {
        location,
        upgradeTier,
        adjusted,
      },
    })
  }

export const countryList = [
    "Canada",
    "Denmark",
    "Israel",
    "Brazil",
    "Australia",
    "Lebanon",
    "Uruguay",
    "Singapore",
    "New Zealand",
    "Britain",
    "South Korea",
    "Chile",
    "United Arab Emirates",
    "Czech Republic",
    "Costa Rica",
    "Colombia",
    "Thailand",
    "Japan",
    "Honduras",
    "Kuwait",
    "Pakistan",
    "Qatar",
    "Croatia",
    "Guatemala",
    "Saudi Arabia",
    "Bahrain",
    "Nicaragua",
    "Sri Lanka",
    "Peru",
    "China",
    "Hungary",
    "Vietnam",
    "Poland",
    "Jordan",
    "Oman",
    "Philippines",
    "India",
    "Hong Kong",
    "Mexico",
    "Indonesia",
    "Azerbaijan",
    "Moldova",
    "Romania",
    "Taiwan",
    "South Africa",
    "Egypt",
    "Malaysia",
    "Argentina",
    "Turkey",
    "Ukraine",
    "Russia",
  ].map((s) => s.toLowerCase())

  export const loadScriptAndExecute = (scriptSrc, command) => {
    const script = document.createElement('script') 
    script.src = scriptSrc
    document.body.appendChild(script) 

    var waitAndExecute = function(key) {
      if (window[key]) {
        window[key]();
      } else {
        setTimeout(function() {
          waitAndExecute(key);
        }, 500);
      }
    };

    script.onload = () => {
      waitAndExecute(command);
    }
  }

  export const getGumroadPricing = (user, scopes) => {
    const metadata = `${process.env.GATSBY_AUTH0_CUSTOMPROPERTYNAMESPACE}/user_metadata`;
    const roles = user[metadata]? user[metadata].roles : [];

    if (!Array.isArray(roles) || !roles.length)
    {
      return null
    }
    
    const rolesUpgradableTo = Object.keys(ROLE_UPGRADES_MAP)
    if (Array.isArray(rolesUpgradableTo) && rolesUpgradableTo.length > 0) {
      let roleToUpgradeTo = "";
      // I search for the first role that let me see this part of the course
      for (const scope of scopes) {
        roleToUpgradeTo = rolesUpgradableTo.find((role) => scope === role)
        if (roleToUpgradeTo)
          break
      }
      
      if (roleToUpgradeTo) {
        for (const userRole of roles) {
          const upgradeFromUserRole = ROLE_UPGRADES_MAP[roleToUpgradeTo].find((upgradeFrom) => upgradeFrom.StartingRole === userRole)
          if (upgradeFromUserRole) {
            return upgradeFromUserRole
          }
        }
      }
    }
  
    return null
  }